<template>
  <div class="cgs-worksheet-updateRow">
    <div class="cgs-updateRow-header">
      <van-nav-bar :border="true">
        <template #left>
          <span class="iconfont cgsIcon-houtui" @click="goBack"></span>
        </template>
        <template #right>
          <!-- <span @click="saveRow">保存</span> -->
          <!-- <div v-if="approved === null">
            <van-button type="primary" @click="() => handleUpdateTask(true)" size="small">通过</van-button>
            <van-button @click="() => handleUpdateTask(false)" size="small" style="margin-left:10px;">否决</van-button>
          </div> -->

          <div v-if="approved === null">
            <van-button type="primary" @click="() => handleUpdateTask(true)" size="small">{{btnName.approveBtn}}
            </van-button>
            <van-button @click="() => handleUpdateTask(false)" size="small" style="margin-left:10px;">
              {{btnName.rejectBtn}}</van-button>
          </div>
          <div v-if="approved === true">
            <span style="color: #4caf50">已通过</span>
          </div>
          <div v-if="approved === false">
            <span style="color: #ee0000">已被否决</span>
          </div>
        </template>
      </van-nav-bar>
    </div>
    <div class="cgs-updateRow-content">
      <v-form-render ref="vFormRef" :form-json="formJson" :form-data="formData" :option-data="optionData"
        class="vFormContent"></v-form-render>
    </div>
  </div>
</template>

<script>
  import {
    NavBar,
    Button
  } from "vant";
  import {
    getWorksheetInfo,
    getRow,
    updateTask,
    getTaskDetail
  } from "@/api/message";
  import {
    getUserAuthority
  } from "@/util/author";
  import "@/assets/style/css/vForm.css";
  export default {
    components: {
      vanNavBar: NavBar,
      vanButton: Button,
    },
    data() {
      return {
        worksheetDetail: {},
        rowDetail: {},
        formJson: {},
        formData: {},
        optionData: {},
        //   dataChanged: false,
        approved: null,
        btnName: {
          approveBtn: '通过',
          rejectBtn: '否决'
        },
      };
    },
    created() {
      window.vformUploadUrlPrefix = process.env.VUE_APP_BASEURL;
    },
    mounted() {
      this.init();
    },
    computed: {
      userId: {
        get() {
          let userAuthority = getUserAuthority();
          return userAuthority.userId;
        },
        set() {},
      },
      taskId: {
        get() {
          return this.$route.params.tableId;
        },
        set() {},
      },
    },
    methods: {
      async init() {
        // this.wholeLoading = true
        try {
          let detail = await getTaskDetail(this.taskId)
          let {
            approveObject: {
              row: {
                worksheetId
              },
              rowId
            },
            approved,
            btnName
          } = detail.data
          if (!btnName) {
            btnName = {
              approveBtn: '通过',
              rejectBtn: '否决'
            }
          }
          let worksheetResult = await getWorksheetInfo(worksheetId);
          let rowRestule = await getRow(worksheetId, rowId);
          this.approved = approved
          this.btnName = btnName;

          this.worksheetDetail = worksheetResult.data;
          this.rowDetail = rowRestule.data;
          if ("config" in this.worksheetDetail) {
            let config =
              this.worksheetDetail.config === "" ? [] :
              JSON.parse(this.worksheetDetail.config);
            config.formConfig.labelPosition = "top";
            this.$refs.vFormRef.setFormJson(config);
            this.$refs.vFormRef.setFormData(this.rowDetail);
            setTimeout(() => {
              this.$refs.vFormRef.disableForm()
            }, 100)
          }
        } catch (e) {
          console.error(e);
        } finally {
          // this.wholeLoading = false
        }
      },
      goBack() {
        this.$router.go(-1);
      },
      // onFormDataChange() {
      //   this.dataChanged = true;
      // },
      async handleUpdateTask(n) {
        this.$Toast.loading({
          message: "提交中...",
          forbidClick: true,
        });
        let formData = await this.$refs.vFormRef.getFormData();
        let result = await updateTask({
          id: this.taskId,
          approved: n,
        });
        let detail = await getTaskDetail(this.taskId)
        window.console.log(detail)
        let {
          approveObject: {
            row: {
              worksheetId
            },
            rowId
          },
          approved,
          btnName
        } = detail.data
        if (!btnName) {
          btnName = {
            approveBtn: '通过',
            rejectBtn: '否决'
          }
        }
        this.approved = approved
        this.btnName = btnName;

        if (result) {
          this.$Notify({
            type: "success",
            message: "提交成功"
          });
          // this.goBack()
        } else {
          this.$Notify({
            type: "danger",
            message: "提交失败"
          });
        }
        //   this.dataChanged = false;
        this.$Toast.clear();
      },
    },
  };
</script>

<style scoped>
  .cgs-worksheet-updateRow {
    /* background: #f5f5f5; */
    display: flex;
    flex-direction: column;
  }

  /* .cgs-appPage-header{
    color: #fff;
} */
  .cgs-updateRow-content {
    /* flex-grow: 1; */
    flex: 1;
    overflow: hidden;
    padding: 10px;
    overflow-y: auto;
  }
</style>